import axios from 'axios';
import store from '../../../store/index';

export default {
	editUser(user) {
		return axios.patch(`/api/users/${user.id}`, user);
	},
	deleteUser(user) {
		return axios.delete(`/api/users/${user.id}`);
	},
	addUser(user) {
		return axios.post('/api/users', user);
	},
	load(id) {
		return axios.get(`/api/users/${id}`);
	},
	getRoles() {
		return axios.get('/api/roles');
	},
	getQualifications() {
		return axios.get('/api/qualifications');
	},
	setPassword(user, password) {
		return axios.patch(`/api/users/${user.id}/password`, {
			password,
			email: user.email,
		});
	},
	createAbsence(absence) {
		return axios.post('/api/absences', absence);
	},
	updateAbsence(absence) {
		const formData = new FormData();

		absence.files.forEach((file) => {
			formData.append('files', file);
		});
		formData.append('changeComment', absence.changeComment ?? '');
		formData.append('description', absence?.description || '');
		formData.append('startDate', absence.startDate);
		formData.append('endDate', absence.endDate);
		formData.append('startTime', absence?.startTime || '');
		formData.append('endTime', absence?.endTime || '');
		formData.append('user', absence.user);
		formData.append('entireDay', absence.entireDay);
		formData.append('type', absence.type);
		if (absence.status !== undefined) {
			formData.append('status', absence.status);
		}
		if (absence.priority !== undefined) {
			formData.append('priority', absence.priority);
		}
		return axios.patch(`/api/absences/${absence.id}`, formData, {
			headers: {
				'Content-Type': 'multipart/form-data',
			},
		});
	},
	deleteAbsence(absenceId, changeComment = null) {
		return axios.delete(`/api/absences/${absenceId}`, {
			data: { changeComment },
		});
	},
	getUsersById() {
		return axios.get('/api/users?by=id');
	},
};
